/**
 * 行政区划服务接口
 * 定义接口
 */
const IEMapService = require('./IEMapService');
/**
 * @description 行政区划统计结果
 * @typedef G.service.IDistrictService~StatisticsResult
 * @type Object
 * @property {Object[]} list
 * @property {Object} [list[n]] 每条统计数
 * @property {String} list[n].id 行政区划编码
 * @property {String} list[n].name 行政区划名称
 * @property {String} list[n].geometry 行政区划位置
 * @property {Number|Object} list[n].value 统计数量，statisticField为空时,value为数值；
 * statisticField不为空时，value为对象，该对象的key为statisticField的枚举值，值为不同枚举值对应的统计数值
 */

/**
 * @classdesc 行政区划服务接口
 * @alias G.service.IDistrictService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IDistrictService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 根据行政区划编码获取行政区划信息
     * @param opts
     * @param opts.code {String[]} 行政区划编码
     * @param opts.returnGeom {Boolean} 是否返回多边形，默认为true
     * @param [opts.distanceTolerance] {Number} 行政区划边界抽稀参数，单位米
     * @returns {Object}
     * @example
//call
service.getDistrict({code:['110000']})
//returns
{
    "code": "110000",
    "name": "北京市",
    "lng": "116",
    "lat": "39",
    //行政区划边界geojson，4326坐标系
    "geom": {}
}
     */
    getDistrict(opts) {}


    /**
     * 获取下级行政区划列表
     * @param {Object} opts 
     * @param {String} opts.code 行政区划编码
     * @param {Number} [opts.distanceTolerance]  行政区划边界抽稀参数，单位米
     * @returns {Object}
     * @example
//call
service.getSubDistrict({code:'450000'});
//returns
{
    "code": "450000",
    "children": [{
        "code": "450100",
        "name": "xx",
        "lng": 120,
        "lat": 113,
        //行政区划边界geojson，4326坐标系
        "geom": {}
    },{...}]
}
     */
    getSubDistrict(opts) {}

    /**
     * 获取点所属行政区划信息
     * @param {Object} opts 
     * @param {Number[]} opts.point 坐标点[x,y]
     * @param {Integer} [opts.spatialReference] 坐标系，默认4326
     * @example
{
  "county": {
    "name": "平谷区",
    "code": "110117"
  },
  "city": {
    "name": "北京市市辖区",
    "code": "110100"
  },
  "province": {
    "name": "北京市",
    "code": "110000"
  }
}
     */
    getDistrictByPoint(opts) {}


    /**
     * 行政区划统计【更新中】
     * @param opts {Object}
     * @param opts.table {String} 表名
     * @param opts.districtField {String} 行政区划字段
     * @param [opts.statisticField] {String} 统计分组字段
     * @param [opts.numberField] {String} 统计计数字段，为空时则统计数量记录数
     * @param [opts.where] {String} 属性过滤条件
     * @param [opts.geometry] {GeoJSON} 空间过滤条件
     * @param [opts.inputSr] {String} 空间过滤条件坐标系
     * @param [opts.spatialRel] {String} 空间关系，可选值[intersects,within]，默认为intersects
     * @returns {G.service.IDistrictService~StatisticsResult}
     */
    districtStatistics(opts) {}

}
module.exports = IDistrictService;